'use client';
import { useEffect } from 'react';

import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import SectionHeader from '@/components/ui/SectionHeader';
import Icon from '@/components/ui/AppIcon';

export default function PortfolioPage() {
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal');
    if (!reveals?.length) return;
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('active')),
      { threshold: 0.1 }
    );
    reveals?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  const flagshipSites = [
    {
      id: 'flagship-1',
      domain: 'JudgmentResolution.com',
      url: 'https://judgmentresolution.com',
      date: '2026',
      summary: 'Professional legal services platform connecting individuals and businesses with judgment resolution specialists. Streamlined process for debt recovery and legal judgment enforcement.',
      services: [
        'Lead Generation Strategy',
        'Local SEO & Maps Optimization',
        'Landing Page Development',
        'PPC Campaign Management'
      ]
    },
    {
      id: 'flagship-2',
      domain: 'StreetSaw.com',
      url: 'https://streetsaw.com',
      date: '2015',
      summary: 'Electronics company that sells e-transportation products such as hoverboards, electric scooters, e-bikes, and more. A leading destination for personal electric mobility solutions.',
      services: [
        'E-commerce Platform',
        'Product SEO & Content',
        'Paid Media Management',
        'Brand Development'
      ]
    },
    {
      id: 'flagship-3',
      domain: 'DriftScooters.com',
      url: 'https://driftscooters.com',
      date: '2017',
      summary: 'Electric scooter enthusiast community and review platform. In-depth product testing, performance comparisons, and maintenance guides for drift scooter riders.',
      services: [
        'Product Review Platform',
        'Video Content Production',
        'Performance Marketing',
        'Community Forum Management'
      ]
    },
    {
      id: 'flagship-4',
      domain: 'Organic101.com',
      url: 'https://organic101.com',
      date: '2015',
      summary: 'Bodycare company selling products such as organic aluminum-free deodorants and luxury lip balms. Focused on clean, natural ingredients and premium personal care for health-conscious consumers.',
      services: [
        'E-commerce Development',
        'Content Marketing Strategy',
        'SEO & Organic Traffic Growth',
        'Brand Development'
      ]
    }
  ];

  const fullPortfolio = [
    {
      id: 'portfolio-gaming-1',
      domain: 'MacPokerOnline.com',
      url: 'https://macpokeronline.com',
      date: 'March 2005',
      summary: 'The premier destination for Mac users seeking niche software platforms. Comprehensive reviews, compatibility guides, and exclusive Mac-optimized software recommendations.',
      services: [
        'SEO Strategy & Implementation',
        'Content Marketing & Editorial',
        'Performance Marketing',
        'Technical Development & Maintenance'
      ]
    },
    {
      id: 'portfolio-gaming-2',
      domain: 'PokerOnAMac.com',
      url: 'https://pokeronamac.com',
      date: 'June 2006',
      summary: 'Dedicated resource for Mac software enthusiasts. Features in-depth platform comparisons, software compatibility testing, and curated software selections for macOS users.',
      services: [
        'Brand Development & Positioning',
        'Content Strategy & Production',
        'Performance Marketing',
        'User Experience Design'
      ]
    },
    {
      id: 'portfolio-gaming-3',
      domain: 'MacPoker.com',
      url: 'https://macpoker.com',
      date: '2012',
      summary: 'Comprehensive Mac software information hub covering everything from beginner guides to advanced strategy. Trusted by thousands of Mac software users worldwide.',
      services: [
        'SEO & Organic Growth',
        'Content Marketing',
        'Community Management',
        'Analytics & Optimization'
      ]
    },
    {
      id: 'portfolio-gaming-4',
      domain: 'HighStakesReport.com',
      url: 'https://highstakesreport.com',
      date: '2006',
      summary: 'Industry-leading publication covering niche industry news, tournament coverage, and professional player profiles. Recognized authority in the niche media landscape.',
      services: [
        'Editorial Strategy & Management',
        'Investigative Journalism',
        'Social Media Marketing',
        'Brand Partnerships'
      ]
    },
    {
      id: 'portfolio-gaming-5',
      domain: 'iMacOnlinePoker.com',
      url: 'https://imaconlinepoker.com',
      date: '2005',
      summary: 'Specialized platform focusing on iMac-optimized online software experiences. Features performance benchmarks, display optimization guides, and curated software selections.',
      services: [
        'Technical SEO',
        'Content Development',
        'Conversion Rate Optimization',
        'Performance Marketing'
      ]
    },
    {
      id: 'portfolio-1',
      domain: 'NoHigh.com',
      url: 'https://nohigh.com',
      date: '2019',
      summary: 'Cannabis industry resource and directory platform. Comprehensive listings, educational content, and industry news for the legal cannabis market.',
      services: [
        'Platform Development',
        'Content Strategy',
        'SEO & Local Search',
        'Directory Management'
      ]
    },
    {
      id: 'portfolio-2',
      domain: 'DuluthPoker.com',
      url: 'https://duluthpoker.com',
      date: '2003',
      summary: 'Regional niche community hub serving Duluth and surrounding areas. Local tournament schedules, player rankings, and directory for the Midwest local digital scene.',
      services: [
        'Community Platform Development',
        'Local SEO',
        'Event Management Systems',
        'Social Media Integration'
      ]
    },
    {
      id: 'portfolio-3',
      domain: 'HealthcareUnlocked.com',
      url: 'https://healthcareunlocked.com',
      date: '2020',
      summary: 'Healthcare company launched at the beginning of the 2020 COVID pandemic that distributed PPE nationwide to the United States. Connecting healthcare providers and businesses with critical protective equipment during a national emergency.',
      services: [
        'E-commerce Platform Development',
        'Healthcare SEO',
        'Supply Chain Content Marketing',
        'Provider Onboarding Systems'
      ]
    },
    {
      id: 'portfolio-6',
      domain: 'HoverboardRepair.com',
      url: 'https://hoverboardrepair.com',
      date: '2016',
      summary: 'Specialized service platform connecting hoverboard owners with certified repair technicians. DIY guides, troubleshooting resources, and nationwide repair network.',
      services: [
        'Service Directory Development',
        'Technical Content Creation',
        'Local SEO & Maps',
        'Lead Generation Systems'
      ]
    },
    {
      id: 'portfolio-8',
      domain: 'SkyhookCapital.io',
      url: 'https://skyhookcapital.io',
      date: '2025',
      summary: 'Real estate company focused on using creative finance strategies such as subject-to, owner finance, wrap-around mortgages, and lease-to-own. Connecting buyers and sellers through innovative financing solutions.',
      services: [
        'Platform Architecture & Development',
        'Financial Content Strategy',
        'Investor Relations Systems',
        'SEO & Lead Generation'
      ]
    },
    {
      id: 'portfolio-9',
      domain: 'BuyMyBusinessIdeas.com',
      url: 'https://buymybusinessideas.com',
      date: '2026',
      summary: 'Marketplace for buying and selling business concepts, domain names, and startup ideas. Secure transaction platform with escrow services and idea validation tools.',
      services: [
        'Marketplace Development',
        'Payment & Escrow Integration',
        'SEO & Content Strategy',
        'User Verification Systems'
      ]
    },
    {
      id: 'portfolio-10',
      domain: 'VelvetAngels.com',
      url: 'https://velvetangels.com',
      date: '2026',
      summary: 'Velvet Angels is a celebrity-worn shoe brand popular in the late 2000s — favored by Kim Kardashian, Melania Trump, PINK, and more — relaunching in 2026 as a full beauty and apparel brand. Best Odds Corp holds an active equity ownership stake in Velvet Angels and has been deeply involved in its revival from the ground up.',
      services: [
        'Pitch Deck Creation',
        'Website Design & Development',
        'Critical Asset Acquisition Negotiation',
        'Fundraising Advisory',
        'WhatsApp Community Build for Founder Collaboration',
        'Corporate Structuring Assistance'
      ]
    }
  ];

  const projectsInProgress = [
    {
      id: 'progress-1',
      domain: 'DanielMoravec.com',
      date: 'Q1 2026',
      summary: 'Personal brand and portfolio website showcasing professional achievements, thought leadership, and consulting services.',
      services: [
        'Personal Brand Strategy',
        'Portfolio Design & Development',
        'Content Management System',
        'SEO Optimization'
      ]
    },
    {
      id: 'progress-2',
      domain: 'ForeclosureResolution.com',
      date: 'Q1 2026',
      summary: 'Legal services platform connecting homeowners facing foreclosure with qualified attorneys and resolution specialists.',
      services: [
        'Lead Generation Platform',
        'Attorney Network Development',
        'Local SEO Strategy',
        'Compliance & Legal Review'
      ]
    },
    {
      id: 'progress-3',
      domain: 'PhysicalBTC.com',
      date: 'Q2 2026',
      summary: 'Physical Bitcoin collectibles marketplace featuring rare coins, commemorative pieces, and authenticated cryptocurrency memorabilia.',
      services: [
        'E-commerce Platform',
        'Authentication Systems',
        'Crypto Payment Integration',
        'Collector Community Features'
      ]
    },
    {
      id: 'progress-4',
      domain: 'FinalTableMastery.com',
      date: 'Q2 2026',
      summary: 'Advanced competitive skills training platform focused on final table strategy, ICM calculations, and tournament finishing techniques.',
      services: [
        'Educational Platform Development',
        'Video Course Integration',
        'Membership & Subscription Systems',
        'Interactive Training Tools'
      ]
    },
    {
      id: 'progress-5',
      domain: 'TickerHaus.com',
      date: 'Q2 2026',
      summary: 'Real-time stock market data and analysis platform with social trading features and portfolio tracking capabilities.',
      services: [
        'Financial Data API Integration',
        'Real-time Dashboard Development',
        'Social Trading Features',
        'Mobile App Development'
      ]
    },
    {
      id: 'progress-6',
      domain: 'LabubuGoldRush.com',
      date: 'Q3 2026',
      summary: 'Labubu collectors guide and course on how to make money buying, selling, and trading Labubu. The definitive resource for collectors looking to profit in the booming Labubu market.',
      services: [
        'Course Platform Development',
        'Community & Membership System',
        'Content Marketing Strategy',
        'SEO & Organic Growth'
      ]
    },
    {
      id: 'progress-7',
      domain: 'DrinkingGames.com',
      date: 'Q3 2026',
      summary: 'Comprehensive database of drinking games, party activities, and social entertainment ideas with user-submitted content.',
      services: [
        'Content Database Development',
        'User-Generated Content Systems',
        'Mobile-Responsive Design',
        'Social Sharing Features'
      ]
    },
    {
      id: 'progress-8',
      domain: 'PlurLife.com',
      date: 'Q3 2026',
      summary: 'Festival culture and rave community platform featuring event calendars, artist lineups, and festival preparation guides.',
      services: [
        'Event Platform Development',
        'Ticketing Integration',
        'Community Features',
        'Content Marketing'
      ]
    },
    {
      id: 'progress-9',
      domain: 'AdioKing.com',
      date: 'Q4 2026',
      summary: 'Brand website of world-class stock market, options, and crypto trader AdioKing. Showcasing trading philosophy, market insights, and educational resources for serious traders.',
      services: [
        'Personal Brand Development',
        'Content Strategy & Production',
        'SEO & Audience Growth',
        'Community Platform'
      ]
    },
    {
      id: 'progress-10',
      domain: 'TarmacFund.com',
      date: 'Q4 2026',
      summary: 'A fund for people who take big swings and risks. The motto: nobody gets on the tarmac without taking risks in life. Built for bold investors who understand that outsized returns require outsized courage.',
      services: [
        'Investment Platform Development',
        'Brand Strategy & Positioning',
        'Investor Portal',
        'Compliance & Regulatory Systems'
      ]
    },
    {
      id: 'progress-11',
      domain: 'Doughery.com',
      date: 'Q4 2026',
      summary: 'Artisan bakery and pastry marketplace connecting local bakers with customers seeking custom cakes and specialty baked goods.',
      services: [
        'Marketplace Platform',
        'Order Management System',
        'Baker Profiles & Portfolios',
        'Local SEO & Marketing'
      ]
    },
    {
      id: 'progress-12',
      domain: 'OddsPricing.com',
      date: '2026',
      summary: 'Prediction market data related website providing real-time odds, market analysis, and pricing intelligence across major prediction markets and forecasting platforms. Domain registered — site in development.',
      services: [
        'Domain Registration'
      ]
    },
    {
      id: 'progress-13',
      domain: 'IntentSniper.com',
      date: '2026',
      summary: 'SaaS product that monitors social media and discovers intent-based content. The app involves itself in the conversation by taking the context and subtly offering a related product or service using our advanced AI agent. Domain registered — site in development.',
      services: [
        'Domain Registration'
      ]
    },
    {
      id: 'progress-14',
      domain: 'PettyDispute.com',
      date: '2026',
      summary: 'A website that uses generative AI to assist in petty disputes such as with Housing, HOA, landlord-tenant, consumer charges & refunds, banking fees, credit card disputes, parking tickets, towing & impound disputes, surprise medical bills, final check disputes, and more. Domain registered — site in development.',
      services: [
        'Domain Registration'
      ]
    }
  ];

  return (
    <>
      <Header />
      <main className="min-h-screen bg-background text-foreground pt-24">
        {/* Hero Section */}
        <section className="py-24 px-6 border-b border-border">
          <div className="max-w-[1600px] mx-auto">
            <div className="reveal">
              <SectionHeader
                eyebrow="Our Portfolio"
                title="Sites, Systems, and Brands We've Built"
                description="A curated collection of websites, platforms, and digital properties built, launched, and scaled since 2000. From niche authority sites to e-commerce brands, real estate platforms, and equity-backed ventures."
                align="center"
                className="mb-16"
              />
            </div>
          </div>
        </section>

        {/* Section A: Flagship Sites */}
        <section className="py-24 px-6 border-b border-border">
          <div className="max-w-[1600px] mx-auto">
            <div className="reveal mb-16">
              <SectionHeader
                eyebrow="Section A"
                title="Flagship Sites"
                description="Our most established and successful digital properties."
                align="left"
              />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {flagshipSites?.map((site) => (
                <div key={site?.id} className="reveal p-8 border border-border hover:border-primary transition-all duration-500 bg-surface-1">
                  <div className="flex items-start justify-between mb-4">
                    <div>
                      <span className="text-micro uppercase tracking-ultra-wide text-primary block mb-2">
                        {site?.date}
                      </span>
                      <h3 className="text-2xl font-semibold mb-2">{site?.domain}</h3>
                    </div>
                    <a
                      href={site?.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="p-2 border border-border hover:border-primary hover:text-primary transition-colors"
                      aria-label={`Visit ${site?.domain}`}
                    >
                      <Icon name="ArrowTopRightOnSquareIcon" size={20} />
                    </a>
                  </div>
                  <p className="text-body-sm text-muted-foreground mb-6 leading-relaxed">
                    {site?.summary}
                  </p>
                  <div>
                    <span className="text-label uppercase tracking-widest text-foreground block mb-3">
                      Services Performed
                    </span>
                    <ul className="space-y-2">
                      {site?.services?.map((service, index) => (
                        <li key={index} className="flex items-start gap-3">
                          <span className="text-primary mt-1">•</span>
                          <span className="text-body-sm text-muted-foreground">{service}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Section B: Full Portfolio List */}
        <section className="py-24 px-6 border-b border-border">
          <div className="max-w-[1600px] mx-auto">
            <div className="reveal mb-16">
              <SectionHeader
                eyebrow="Section B"
                title="Full Portfolio List"
                description="Additional sites and platforms across various industries."
                align="left"
              />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {fullPortfolio?.map((site) => (
                <div key={site?.id} className="reveal p-8 border border-border hover:border-primary transition-all duration-500 bg-surface-1">
                  <div className="flex items-start justify-between mb-4">
                    <div>
                      <span className="text-micro uppercase tracking-ultra-wide text-primary block mb-2">
                        {site?.date}
                      </span>
                      <h3 className="text-2xl font-semibold mb-2">{site?.domain}</h3>
                    </div>
                    <a
                      href={site?.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="p-2 border border-border hover:border-primary hover:text-primary transition-colors"
                      aria-label={`Visit ${site?.domain}`}
                    >
                      <Icon name="ArrowTopRightOnSquareIcon" size={20} />
                    </a>
                  </div>
                  <p className="text-body-sm text-muted-foreground mb-6 leading-relaxed">
                    {site?.summary}
                  </p>
                  <div>
                    <span className="text-label uppercase tracking-widest text-foreground block mb-3">
                      Services Performed
                    </span>
                    <ul className="space-y-2">
                      {site?.services?.map((service, index) => (
                        <li key={index} className="flex items-start gap-3">
                          <span className="text-primary mt-1">•</span>
                          <span className="text-body-sm text-muted-foreground">{service}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Projects In Progress Section */}
        <section className="py-24 px-6 border-b border-border">
          <div className="max-w-[1600px] mx-auto">
            <div className="reveal mb-16">
              <SectionHeader
                eyebrow="Coming Soon"
                title="Projects In Progress"
                description="Currently in development. These sites are being built and will launch throughout 2026."
                align="left"
              />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {projectsInProgress?.map((site) => (
                <div key={site?.id} className="reveal p-8 border border-border bg-surface-1 opacity-75">
                  <div className="mb-4">
                    <span className="text-micro uppercase tracking-ultra-wide text-primary block mb-2">
                      {site?.date}
                    </span>
                    <h3 className="text-2xl font-semibold mb-2">{site?.domain}</h3>
                  </div>
                  <p className="text-body-sm text-muted-foreground mb-6 leading-relaxed">
                    {site?.summary}
                  </p>
                  <div>
                    <span className="text-label uppercase tracking-widest text-foreground block mb-3">
                      Services Planned
                    </span>
                    <ul className="space-y-2">
                      {site?.services?.map((service, index) => (
                        <li key={index} className="flex items-start gap-3">
                          <span className="text-primary mt-1">•</span>
                          <span className="text-body-sm text-muted-foreground">{service}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-24 px-6">
          <div className="max-w-[1600px] mx-auto text-center">
            <div className="reveal">
              <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-6">
                Ready to Build the Next One?
              </h2>
              <p className="text-lg text-muted-foreground max-w-2xl mx-auto mb-8">
                Every engagement starts with a Sprint — a paid diagnostic that maps your constraints and delivers a clear execution roadmap.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="/book"
                  className="inline-block px-8 py-4 bg-primary text-primary-foreground text-xs uppercase tracking-widest hover:bg-primary/90 transition-colors font-semibold border-glow"
                >
                  Book a Sprint — Start With a Diagnostic
                </a>
                <a
                  href="/case-studies"
                  className="inline-block px-8 py-4 border border-border text-foreground text-xs uppercase tracking-widest hover:border-primary hover:text-primary transition-colors font-semibold"
                >
                  View Proof & Process
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}